import React from "react";
import { AccordionDetails } from "@mui/material";

const DSAccordionDetails = (
  props: React.ComponentProps<typeof AccordionDetails>,
) => {
  return <AccordionDetails {...props} />;
};

export default DSAccordionDetails;
